<template>
  <main class="main home-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper home">
          <div class="text">
            <div class="title title-24">
              Welcome to {{ $parent.hostname }} -
            </div>
            <div class="title title-62">
              <b>Your Ultimate CS2 Skins Shop</b>
            </div>
            <router-link to="product-list/all" class="button">
              <span>Shop now</span></router-link
            >
          </div>
        </div>
      </div>
      <div class="section arrivals-section sale-section">
        <div class="wrapper">
          <div class="top">
            <div class="title main-title">
              <img class="img" src="./../img/discount.svg" />
              <b>Discount Store</b>
            </div>
            <router-link to="/sale" class="link">
              <span>see all</span>
            </router-link>
          </div>
          <SlickItem
            v-if="$parent.saleProducts.length"
            :list="$parent.saleProducts"
            :tag="'Sale'"
            :addToCartChosenItem="addToCartChosenItem"
            @addToCart="addToCart"
            @goToProduct="goToProduct"
            :currency="currency"
          />
        </div>
      </div>
      <div
        class="section category-section"
        v-if="$parent.categoryOptions.length"
      >
        <div class="wrapper">
          <div class="list">
            <div
              class="item"
              v-for="item in $parent.categoryOptions"
              :key="item"
            >
              <div
                class="item-wrapper"
                @click="$parent.setProductCategory(item)"
              >
                <img :src="getImagePath(item)" class="img" />
                <div class="title">
                  <b>{{ item }}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section more-offers-section">
        <div class="wrapper">
          <div class="title title-62">
            <b>Discover the Skins That Define Your Game</b>
          </div>
          <div class="desc desc-14">
            Step into the world of Counter-Strike 2 like never before with our exclusive collection of skins. Whether you're looking for rare, legendary, or trending designs, we've got everything you need to level up your gameplay and style
          </div>
          <router-link to="product-list/all" class="button">
            <span>Shop now</span>
          </router-link>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import SlickItem from "../components/SlickItem.vue";

export default {
  name: "Home",
  props: ["addToCartChosenItem", "currency"],
  components: {
    SlickItem,
  },
  data: function () {
    return {
      imgDomain: "",
      dailyOffer: {},
      sliderIsClickble: true,
      slickOptions: {
        slidesToShow: 8,
        slidesToScroll: 5,
        arrows: false,
        infinite: false,
        dots: false,
        responsive: [
          {
            breakpoint: 1240,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 4,
            },
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            },
          },
          {
            breakpoint: 560,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.getDailyOffer();
  },
  methods: {
    getImagePath(item) {
      const cleanItem = item.replace(/\s+/g, "");
      return require(`@/img/types/${cleanItem.toLowerCase()}.webp`);
    },
    getDailyOffer() {
      this.$http
        .get(process.env.VUE_APP_API + "items/daily")
        .then((res) => {
          console.log(res);
          this.dailyOffer = res.data.payload;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
        });
    },
    goToProduct(item) {
      this.$emit("goToProduct", item);
    },
    addToCart(item, id) {
      this.$emit("addToCart", item, id);
    },
    handleSwipe() {
      let self = this;
      self.sliderIsClickble = false;
      setTimeout(() => {
        self.sliderIsClickble = true;
      }, 300);
    },
  },
};
</script>
